import { getConfigManager } from '../../config/getConfigManager';
import { Decimal } from '../../datastructures';
import poolsTvlAtom from './poolTvlAtom';
import poolsShareAtom from './poolsShareAtom';
import { createAsyncAtom } from '../../lib/state';

const poolsPairBalanceAtom = createAsyncAtom(async get => {
  const poolsTvl = await get(poolsTvlAtom);
  const poolsShare = await get(poolsShareAtom);

  const pools = getConfigManager().getConfig().pools;

  const poolsPairBalanceMap: { [pairId: string]: { tokenA: Decimal; tokenB: Decimal } } = {};
  Object.entries(pools).map(([, pool]) => {
    const tvl = poolsTvl[pool.pair.id];
    const share = poolsShare[pool.pair.id];

    if (tvl && share) {
      poolsPairBalanceMap[pool.pair.id] = {
        tokenA: tvl.tokenA.mul(share),
        tokenB: tvl.tokenB.mul(share),
      };
    } else {
      poolsPairBalanceMap[pool.pair.id] = {
        tokenA: new Decimal(0),
        tokenB: new Decimal(0),
      };
    }
  });

  return poolsPairBalanceMap;
});
export default poolsPairBalanceAtom;
